module.exports = __webpack_public_path__ + "img/4-1_07.5bc243da.jpg";